module.exports = __webpack_public_path__ + "static/media/21ECLAC49.3708c065.jpg";